import { BaseApi } from './base.api.js';

export class ApplicationMethodApi extends BaseApi {
    constructor(client) {
        super(client, '/application-method');
    }
}
